import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

const BreadcrumbMenu = ({
    homeMenuDisplay = false,
    hotelListDisplay = false,
    hotelDetailsDisplay = false,
    bookingListDisplay = false,
    profileDisplay = false,
    changePasswordDisplay = false,
    aboutDisplay = false,
    t_c_Display = false,
    faq_Display = false,
    PrivacyPolicy_Display = false,
    Sitemap_Display = false,
    creditNoteListDisplay = false,
    tourListDisplay = false,
    tourDetailsDisplay = false,

    homeMenuClick,
    hotelListClick,
    hotelDetailsClick,
    bookingListClick,
    profileMenuClick,
    changePasswordClick,
    creditNoteClick,
    tourListClick,
    tourDetailsClick,

    activeHome = false,
    activeHotelList = false,
    activeHotelDetails = false,
    activeBookingList = false,
    activeProfile = false,
    activeChangePassword = false,
    activeAbout = false,
    active_t_c = false,
    active_faq = false,
    active_PrivacyPolicy = false,
    active_Sitemap = false,
    activeCreditNoteList = false,
    activeTourList = false,
    activeTourDetails = false
}) => {
    return (
        <Breadcrumb className="breadcrumbSec">
            {homeMenuDisplay && (
                <Breadcrumb.Item onClick={homeMenuClick} active={activeHome}>
                    Home
                </Breadcrumb.Item>
            )}

            {hotelListDisplay && (
                <Breadcrumb.Item onClick={hotelListClick} active={activeHotelList}>
                    Property List
                </Breadcrumb.Item>
            )}

            {hotelDetailsDisplay && (
                <Breadcrumb.Item onClick={hotelDetailsClick} active={activeHotelDetails}>
                    Property Details
                </Breadcrumb.Item>
            )}

            {bookingListDisplay && (
                <Breadcrumb.Item onClick={bookingListClick} active={activeBookingList}>
                    Booking History
                </Breadcrumb.Item>
            )}

            {profileDisplay && (
                <Breadcrumb.Item onClick={profileMenuClick} active={activeProfile}>
                    Profile
                </Breadcrumb.Item>
            )}

            {changePasswordDisplay && (
                <Breadcrumb.Item onClick={changePasswordClick} active={activeChangePassword}>
                    Change Password
                </Breadcrumb.Item>
            )}

            {aboutDisplay && (
                <Breadcrumb.Item active={activeAbout}>
                    About Us
                </Breadcrumb.Item>
            )}

            {t_c_Display && (
                <Breadcrumb.Item active={active_t_c}>
                    Terms &amp; Conditions
                </Breadcrumb.Item>
            )}

            {faq_Display && (
                <Breadcrumb.Item active={active_faq}>
                    FAQ
                </Breadcrumb.Item>
            )}

            {PrivacyPolicy_Display && (
                <Breadcrumb.Item active={active_PrivacyPolicy}>
                    Privacy Policy
                </Breadcrumb.Item>
            )}

            {Sitemap_Display && (
                <Breadcrumb.Item active={active_Sitemap}>
                    Sitemap
                </Breadcrumb.Item>
            )}

            {creditNoteListDisplay && (
                <Breadcrumb.Item onClick={creditNoteClick} active={activeCreditNoteList}>
                    Credit Notes
                </Breadcrumb.Item>
            )}

            {tourListDisplay && (
                <Breadcrumb.Item onClick={tourListClick} active={activeTourList}>
                    Tour List
                </Breadcrumb.Item>
            )}

            {tourDetailsDisplay && (
                <Breadcrumb.Item onClick={tourDetailsClick} active={activeTourDetails}>
                    Tour Details
                </Breadcrumb.Item>
            )}
        </Breadcrumb>
    );
};

BreadcrumbMenu.propTypes = {
    homeMenuDisplay: PropTypes.bool,
    hotelListDisplay: PropTypes.bool,
    hotelDetailsDisplay: PropTypes.bool,
    bookingListDisplay: PropTypes.bool,
    profileDisplay: PropTypes.bool,
    changePasswordDisplay: PropTypes.bool,
    aboutDisplay: PropTypes.bool,
    t_c_Display: PropTypes.bool,
    faq_Display: PropTypes.bool,
    PrivacyPolicy_Display: PropTypes.bool,
    Sitemap_Display: PropTypes.bool,
    creditNoteListDisplay: PropTypes.bool,
    tourListDisplay: PropTypes.bool,
    tourDetailsDisplay: PropTypes.bool,

    homeMenuClick: PropTypes.func,
    hotelListClick: PropTypes.func,
    hotelDetailsClick: PropTypes.func,
    bookingListClick: PropTypes.func,
    profileMenuClick: PropTypes.func,
    changePasswordClick: PropTypes.func,
    creditNoteClick: PropTypes.func,
    tourListClick: PropTypes.func,
    tourDetailsClick: PropTypes.func
};

export default BreadcrumbMenu;
